module.exports = __webpack_public_path__ + "static/media/dotted_line.aefc70a5.svg";